// extracted by mini-css-extract-plugin
export default {"cell":"Row_cell__8s0Oz"};